import { useEffect, useState } from "react";
import { FreeSubscription } from "@/common/model/FreeSubscription";
import { FreeSubscriptionService } from "@/services/FreeSubscriptionService";
import { User } from "@/common/model/User";
import FreeSubscriptionManager from "@/components/free-subscription/FreeSubscriptionManager";

const FreeSubscriptionsPage = () => {
  const [subscriptions, setSubscriptions] = useState<FreeSubscription[]>([]);
  const [selectedTab, setSelectedTab] = useState("active");
  const [selectedUser, setSelectedUser] = useState<User | null>(null);

  useEffect(() => {
    const fetchSubscriptions = async () => {
      const response = await FreeSubscriptionService.fetchAll();
      setSubscriptions(response);
      let filteredSubscriptions = response;
      if (selectedTab !== "all") {
        filteredSubscriptions = filteredSubscriptions.filter(
          (sub) => sub.status === selectedTab
        );
      } else {
        filteredSubscriptions = response;
      }

      if (selectedUser !== null) {
        filteredSubscriptions = filteredSubscriptions.filter(
          (sub) => sub.userId === selectedUser.id
        );
      }
      setSubscriptions(filteredSubscriptions);
    };
    fetchSubscriptions();
  }, [selectedTab, selectedUser]);

  const handleUserSelect = (selectedUser: User | null) => {
    setSelectedUser(selectedUser);
  };

  const handleTabSelect = (tab: string) => {
    setSelectedTab(tab);
  };

  return (
    <FreeSubscriptionManager
      selectedTab={selectedTab}
      onSelectTab={(tab: string) => handleTabSelect(tab)}
      selectedUser={selectedUser}
      onSelectUser={handleUserSelect}
      subscriptions={subscriptions}
      setSubscriptions={setSubscriptions}
    />
  );
};

export default FreeSubscriptionsPage;
